module.exports = __webpack_public_path__ + "img/buy-icon5.32afad0.png";